import PropTypes from 'prop-types';
import React from 'react';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import getSendingEmployeeName from 'src/components/Dashboard/utils/getSendingEmployeeName';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import _ from 'lodash';
import FilterBar from '../FilterBar';
import { programColumn } from '../../utils/columnConfigs/baseColumns';

function populateSentByField(referrals) {
  return referrals.map((referral) => {
    const sent_by = getSendingEmployeeName(referral);
    return { ...referral, sent_by };
  });
}

function getColumns(setSort, sortConfig, showProgramNameColumn) {
    const lastUpdatedColumn = {
      label: 'Last Updated',
      sortColumn: 'updated_at',
      type: 'date',
    };

    if (setSort && sortConfig) {
      lastUpdatedColumn.sortBy = sortConfig?.sidx;
      lastUpdatedColumn.sortDirection = sortConfig?.sord;
      lastUpdatedColumn.setSort = ({ sortBy }) => setSort(sortBy);
    }

    return [
      {
        label: 'Sent by',
        sortColumn: 'sent_by',
      },
      {
        label: 'Recalled From',
        sortColumn: 'referred_to_group.name',
      },
      {
        label: 'Client Name',
        sortColumn: 'contact.full_name',
      },
      {
        label: 'Service Type',
        sortColumn: 'service_type.name',
      },
      ...(showProgramNameColumn ? [programColumn('referred_to_program.name', sortConfig, setSort)] : []),
      lastUpdatedColumn,
    ];
}

export function RecalledReferralsIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    onFiltersChange,
    filters,
    fetchGroupsUsers,
    sortConfig,
    setSort,
    showProgramNameColumn,
  } = props;
  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Recalled referrals"
                id="recalled-referrals-table"
                dataSet={populateSentByField(data)}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(setSort, sortConfig, showProgramNameColumn)}
                emptyMessage="There are no recalled referrals."
                rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
              />
            )
        }
      </div>
    </div>
  );
}

RecalledReferralsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  onFiltersChange: PropTypes.func,
  filters: PropTypes.array,
  fetchGroupsUsers: PropTypes.func.isRequired,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
  showProgramNameColumn: PropTypes.bool,
};

RecalledReferralsIndex.defaultProps = {
  sortConfig: null,
  setSort: null,
  showProgramNameColumn: false,
};

export default RecalledReferralsIndex;
